import * as React from "react";

import { cn } from "../../lib/utils";
import { FormItemContext } from "./form-item-context";

export const FormItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const id = React.useId();
  const [controlId, setControlId] = React.useState<string | undefined>();

  return (
    <FormItemContext.Provider value={{ id, controlId, setControlId }}>
      <div ref={ref} className={cn("space-y-2", className)} {...props} />
    </FormItemContext.Provider>
  );
});
FormItem.displayName = "FormItem";
